import React from 'react';
import { Table as MuiTable, TableBody, TableHead, TableRow } from '@mui/material';
import { TableContainer, StyledPaper, TableTitle, StyledTableCell } from './Table.styles';

const CustomTable = ({ columns, rows, title }) => {
    return (
        <TableContainer>
            <StyledPaper>
                {title && <TableTitle>{title}</TableTitle>}
                <MuiTable>
                    <TableHead>
                        <TableRow>
                            {columns.map((col) => (
                                <StyledTableCell key={col.id}>{col.label}</StyledTableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, index) => (
                            <TableRow key={index}>
                                {columns.map((col) => (
                                    <StyledTableCell key={col.id}>{row[col.id]}</StyledTableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </MuiTable>
            </StyledPaper>
        </TableContainer>
    );
};

export default CustomTable;
